import { NotificationHandler } from '@Components';
import { ResponseError } from './ApiService';

type ResponseData = {
    error?: string;
}

class ErrorHandleService {
    private _lastError: { message: string, time: number };

    async showError(url: string, error: ResponseError<ResponseData>) {
        let errorMessage = '';
        const currentTime = (new Date()).getTime();
        console.log('--error AJAX: ', error);
        if (!this._lastError || this._lastError.message !== error.message || (currentTime - this._lastError.time > 10000)) {
            if (!error?.response) {
                const defaultErrorMessage = 'Something went wrong... Try again in a little bit.';
                errorMessage = error.message || defaultErrorMessage;
                NotificationHandler.showError(errorMessage, '--error AJAX');
            }
            else {
                const notificationTitle = error.response.statusText;
                const notificationMessage = error.response.data.error || error.message;

                NotificationHandler.showError(notificationMessage, notificationTitle);

                this._lastError = { message: error.message, time: currentTime };
            }
        }
    }
}

export const errorHandleService = new ErrorHandleService();